









































































import { Component, Vue, Watch } from "vue-property-decorator";
import { apiService, Interfaces, AppConstants, Models, Utils } from "@/core/Export";
import store from "@/store";
import { date } from "quasar";
@Component({
  components: {},
})
export default class ReportMissingEvent extends Vue {
  missingEventModel: Models.MissingEvent;
  dateMask: string;
  urlToUpload: string;
  uploadExtensions: string;
  files: FormData;
  hasUploadFile: boolean;
  permissions: any;
  isSaveButtonDisabeld: boolean;
  isShowPartialInPortal: boolean;
  isShowFillTekenInPortal: boolean;
  permissionsEventWithoutRemark: boolean;
  budgetItemsDS: any[] = [];
  budgetItemsDSInit: any[] = [];

  originalMissingEventsItems: any[] = [];
  missingEventsItems: any[] = [];

  constructor() {
    super();
    this.missingEventModel = new Models.MissingEvent();
    this.dateMask = "DD/MM/YYYY";
    this.urlToUpload = AppConstants.Http.BaseUrl + "/uploadFiles";
    this.uploadExtensions = ".jpg,.jpeg,.pdf";
    this.hasUploadFile = false;
    this.files = new FormData();
    this.permissions = AppConstants.Permissions;
    this.isSaveButtonDisabeld = false;
    this.isShowPartialInPortal = false;
    this.isShowFillTekenInPortal = false;
  }

  async created() {
    await this.getPortalMissingEvents();
    await this.onLoadMissingEventModel();
    this.getBudgetItemsDS();
  }

  async getPortalMissingEvents() {
    try {
      this.appEnv.isBusy = true;
      let res = await apiService.getPortalMissingEvents();
      let result: Interfaces.iServiceRequest = res;
      let call = result.calls[0] as Interfaces.iServiceCall;
      if (call && call.isSuccess) {
        this.originalMissingEventsItems = call.callResult.data;
        this.missingEventsItems = call.callResult.data;
      }
    } finally {
      this.appEnv.isBusy = false;
    }
  }

  @Watch("missingEventModel.fromDate")
  @Watch("missingEventModel.toDate")
  onDateChanged() {
    this.missingEventModel.budgetItemId = 0;
    this.getBudgetItemsDS();
  }

  getBudgetItemsDS() {
    if (!this.missingEventModel.fromDate || !this.missingEventModel.forceSpecialEvent) return;
    this.appEnv.isBusy = true;
    apiService.getBudgetItemsDS(this.missingEventModel.fromDate, this.missingEventModel.toDate, this.missingEventModel.employeeId)
      .then(res => {
        let result: Interfaces.iServiceRequest = res;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          this.budgetItemsDS = call.callResult.data;
          this.budgetItemsDSInit = call.callResult.data;
        }
      })
      .finally(() => {
        this.appEnv.isBusy = false;
      })
  }

  onFiterMissingEventModel(val, update, abort) {
    update(() => {
      const needle = val.toLowerCase();
      this.missingEventsItems = this.originalMissingEventsItems.filter((v) =>
        v.name.includes(needle)
      );
    });
  }

  onFiterBudgetItems(val, update, abort) {
    update(() => {
      const needle = val.toLowerCase();
      this.budgetItemsDS = this.budgetItemsDSInit.filter((v) =>
        v.name.includes(needle)
      );
    });
  }

  onMissingEventIdChanged(e) {
    let missingEvent = this.missingEventsItems.find((q) => q.id === e);

    
    if (missingEvent) {
      this.isShowPartialInPortal = missingEvent.addField2; //isShowPartialInPortal
      this.isShowFillTekenInPortal = missingEvent.addField3; //isShowFillTekenInPortal
    } else {
      this.isShowPartialInPortal = false;
      this.isShowFillTekenInPortal = false;
    }

    const filterNonDaySelection = missingEvent && missingEvent.addField6 == false; 
    if (filterNonDaySelection) {
      this.isShowPartialInPortal = false;
    }
    
    if (!this.isShowFillTekenInPortal || !this.isShowPartialInPortal) {
      this.missingEventModel.missingEventOption = this.missingEventOptions[0].value;
    }

    if (!this.isShowPartialInPortal) {
      this.missingEventModel.fromTimeText = null;
      this.missingEventModel.toTimeText = null;
    }



    if (this.permissions.EventWithoutRemark) {
      if (missingEvent.addField5) {
        this.permissionsEventWithoutRemark = true;
      }
      else {
        this.permissionsEventWithoutRemark = false;
      }

    }

  }

  onMissingEventOptionChanged(value) {
    if (
      (value != 3 && this.missingEventModel.fromTimeText) ||
      this.missingEventModel.toTimeText
    ) {
      this.missingEventModel.fromTimeText = null;
      this.missingEventModel.toTimeText = null;
    }

    if (value != 4) {
      this.missingEventModel.isDeleteFiles = false;
    }
    if (value == 4) {
      this.missingEventModel.isDeleteFiles = true;
    }
  }

  onLoadMissingEventModel() {
    this.appEnv.isBusy = true;
    apiService
      .getSingle(AppConstants.Entites.MissingEventSingleReport, { id: -1, employeeId: this.currentEmployee.id })
      .then((res) => {
        let result: Interfaces.iServiceRequest = res;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          this.missingEventModel = call.callResult.data as Models.MissingEvent;
          this.missingEventModel.employeeId = this.currentEmployee.id;
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
        this.appEnv.isBusy = false;
      })
      .catch((err) => {
        this.appEnv.isBusy = false;
      });
  }

  onSaveMissingEvent(e) {
    e.preventDefault();
    let missingEventForm = this.$refs.missingEventForm as any;
    missingEventForm.validate().then((success) => {
      if (success && !this.hasMissingEventRequiredFileError()) {
        let format = "DD/MM/YYYY";
        let fromDate = date.extractDate(this.missingEventModel.fromDate, format);
        let toDate = date.extractDate(this.missingEventModel.toDate, format);

        let diff = date.getDateDiff(toDate, fromDate, "days");
        if (diff > 120) {
          this.$q.dialog({
            title: this.$t('msgs.error') as string,
            message: this.$t('msgs.report_missing_event_more_than_120_days_confirm') as string,
            ok: this.$t("approve"),
          }).onOk(() => {
          })
        } else if (diff > 30) {
          this.$q.dialog({
            title: this.$t("verification") as string,
            message: this.$t('msgs.report_missing_event_more_than_30_days_confirm') as string,
            ok: this.$t("approve"),
            cancel: this.$t("reject"),
          }).onOk(() => {
            this.uploadFile();
          }).onCancel(() => {
          })
        } else {
          this.uploadFile();
        }
      }
    });
  }

  uploadFile() {
    if (this.hasFilesInFormData()) {
      this.isSaveButtonDisabeld = true;
      this.appEnv.isBusy = true;
      apiService
        .uploadFiles(this.files, this.uploadHeaders)
        .then((res) => {
          if (res.isSuccess) {
            this.missingEventModel.fileIds = res.calls[0].callResult.fileIds;
            this.saveSingleMissingEvent();
            this.hasUploadFile = true;
          } else {
            this.isSaveButtonDisabeld = false;
            this.appEnv.isBusy = false;
            this.appEnv.showErrorDialog(res["msgs"].msgs);
          }
        })
        .catch((err) => {
          this.isSaveButtonDisabeld = false;
          this.appEnv.isBusy = false;
        });
    } else {
      this.saveSingleMissingEvent();
    }
  }

  formatDates(date: any): string {
    if (!date) return null;
    
    let year: number, month: number, day: number;
    
    if (date instanceof Date) {
        year = date.getFullYear();
        month = date.getMonth();
        day = date.getDate();
    } else if (typeof date === 'string' && date.includes('/')) {
        const [d, m, y] = date.split('/').map(p => parseInt(p, 10));
        day = d;
        month = m - 1; // חודשים ב-JS מתחילים מ-0
        year = y < 100 ? (y < 50 ? 2000 + y : 1900 + y) : y;
    } else {
        return null;
    }
    
    return new Date(Date.UTC(year, month, day, 0, 0, 0, 0)).toISOString();
  }


  saveSingleMissingEvent() {
    this.isSaveButtonDisabeld = true;
    this.appEnv.isBusy = true;

    let modelToSave = JSON.parse(JSON.stringify(this.missingEventModel));
    if (modelToSave != null && modelToSave.hasOwnProperty("missingEvents")) modelToSave.missingEvents = [];
        // תיקון פורמט התאריכים לפני השליחה
    if (modelToSave.fromDate) {
        modelToSave.fromDate = this.formatDates(modelToSave.fromDate);
    }
    if (modelToSave.toDate) {
        modelToSave.toDate = this.formatDates(modelToSave.toDate);
    }
    debugger;

    apiService
      .saveSingleMissingEvent(AppConstants.Entites.MissingEventSingleReport, modelToSave)
      .then((res) => {
        let result: Interfaces.iServiceRequest = res;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          store.dispatch(AppConstants.StoreActions.GetEmployeeMonthAttendViewData);
          this.onCloseMissingEventDrawer();
          Utils.Notification.notifyPositive(this.$t("msgs.save").toString(), "thumb_up");
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
        this.isSaveButtonDisabeld = false;
        this.appEnv.isBusy = false;
      })
      .catch((err) => {
        this.isSaveButtonDisabeld = false;
        this.appEnv.isBusy = false;
      });
  }

  onAddFile(files) {
    for (let file of files) {
      this.files.append(`eventFile~${file.name}`, file, file.name);
    }
    this.$forceUpdate();
  }

  onFileRemoved(files) {
    for (let file of files) {
      this.files.delete(`eventFile~${file.name}`);
    }
    this.$forceUpdate();
  }

  validateComment(value) {
    if (this.permissionsEventWithoutRemark) {
      return !value ? false : true;
    }
    if (this.appEnv.isAllowed(this.permissions.EventWithoutRemark)) {
      return true;
    } else {
      return !value ? false : true;
    }
  }

  validateReplaceMissingEvent(value) {
    if (this.missingEventModel.missingEventOption == 6) {
      if (!value) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  validateTime(value) {
    if (this.missingEventModel.missingEventOption == 3) {
      if (!value) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  onFromTimeChanged(e) {
    this.missingEventModel.fromTimeText = Models.AppUtils.formatTime(e.target.value);
  }

  onToTimeChanged(e) {
    this.missingEventModel.toTimeText = Models.AppUtils.formatTime(e.target.value);
  }

  onCloseMissingEventDrawer() {
    store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, false);
    store.commit(AppConstants.StoreMutations.UpdateLeftDrawerComponnent, null);
  }

  hasFilesInFormData() {
    let hasFile = false;
    for (let file of this.files.values()) {
      hasFile = true;
      break;
    }
    return hasFile;
  }

  hasMissingEventRequiredFileError() {
    if (this.missingEventModel.missingEventId > 0) {
      let missingEvent = null;
      if (
        this.missingEventModel.missingEventOption == 6 &&
        this.missingEventModel.replaceMissingEventId > 0
      ) {
        missingEvent = this.missingEventsItems.find(
          (s) => s.id == this.missingEventModel.replaceMissingEventId
        );
      } else {
        missingEvent = this.missingEventsItems.find(
          (s) => s.id == this.missingEventModel.missingEventId
        );
      }
      return (
        missingEvent &&
        missingEvent.addField4 &&
        this.missingEventModel.missingEventOption != 4 &&
        !this.hasFilesInFormData()
      );
    } else {
      return false;
    }
  }

  get uploadHeaders() {
    return {
      customercode: this.appEnv.customerCode ? this.appEnv.customerCode : "",
      accesstoken: this.appEnv.UserInfo.accessToken,
      sourcetype: AppConstants.EntityType.Employee,
      sourceid: this.missingEventModel.employeeId,
    };
  }

  get missingEventOptions() {
    let baseMissingEvents = [];
    baseMissingEvents.push({ label: this.$t("missingEventOptions.fullDay"), value: 1 });
    if (this.isShowFillTekenInPortal) {
      baseMissingEvents.push({
        label: this.$t("missingEventOptions.fillTeken"),
        value: 2,
      });
    }
    if (this.isShowPartialInPortal) {
      baseMissingEvents.push({
        label: this.$t("missingEventOptions.paritalAttend"),
        value: 3,
      });
    }
    if (this.isAllowUploadAttachment) {
      baseMissingEvents.push({
        label: this.$t("missingEventOptions.uploadFiles"),
        value: 5,
      });
    }
    baseMissingEvents.push({
      label: this.$t("missingEventOptions.replaceFullDay"),
      value: 6,
    });
    baseMissingEvents.push({
      label: this.$t("missingEventOptions.deletionAttend"),
      value: 4,
    });
    return baseMissingEvents;
  }

  get currentEmployee() {
    return store.getters.currentEmployee;
  }

  get isAllowUploadAttachment() {
    if (this.appEnv.isAllowed(
      AppConstants.Permissions.PortalUploadAttachment
    )
    ) {
      return true;
    }
    return false;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
